<template lang='pug'>
  el-dialog(title="确认匹配条件", :visible.sync="visible")
    p(v-for="v,k in msg") {{k}}：{{v}}
    span(slot="footer")
      el-button(@click="cancelMatch") 取消
      el-button(@click="submitMatch", type="primary") 确认
</template>

<script>
// Generated by CoffeeScript 2.3.0
var dateFormat, m,
  indexOf = [].indexOf;

dateFormat = require('dateformat');

export default m = {
  data: function() {
    return {
      chks: [],
      chkOptions: ['职级', '平台', '业绩'],
      sl: [],
      visible: false,
      item: {},
      msg: {}
    };
  },
  methods: {
    show: function(item) {
      return app.api.find({
        tableName: 'searchlists',
        query: {
          "project._id": item._id
        }
      }).then((res) => {
        var cols, query, tmp;
        query = {};
        tmp = true;
        cols = ['职能模块', '职级', '平台', '业绩'];
        cols.map((col) => {
          if (!item[col]) {
            this.$message({
              type: 'info',
              message: '请先填写' + this.chkOptions
            });
            tmp = false;
          }
          return this.msg[col] = item[col];
        });
        if (tmp) {
          this.sl = res;
          this.item = item;
          return this.visible = true;
        }
      });
    },
    hide: function() {
      return this.visible = false;
    },
    cancelMatch: function() {
      this.chks = [];
      return this.hide();
    },
    submitMatch: function() {
      var project;
      project = this.item;
      return Promise.resolve().then(() => {
        var candi, query;
        query = {
          '职能模块': project['职能模块']
        };
        candi = [];
        this.chkOptions.map((col) => {
          var qu;
          qu = project[col].split('');
          return query[`${col}`] = {
            $in: qu
          };
        });
        // console.log query
        return app.api.find({
          tableName: 'candidates',
          query: query
        }).then((cand) => {
          var cids, item, ref, rows, slist;
          // console.log cand
          // return false
          if (cand) {
            candi = cand.map((c) => {
              return {
                _id: c._id,
                '意向': '',
                '添加时间': dateFormat(new Date(), 'yy/mm/dd HH:MM')
              };
            });
          }
          if (this.sl.length === 0) {
            item = {
              '名称': `项目：${project['客户公司']}-${project['所属部门']}-${project['岗位名称']}`,
              '创建人': (ref = app.user) != null ? ref['account'] : void 0,
              candidates: candi,
              project: {
                _id: this.projectId
              },
              permissions: project.permissions
            };
            return app.api.create({
              tableName: 'searchlists',
              data: item
            }).then((sl) => {
              if (candi) {
                candi.map((c) => {
                  return app.api.update({
                    tableName: 'candidates',
                    _id: c._id,
                    data: {
                      searchlists: {
                        [`${sl._id}`]: '1'
                      }
                    }
                  });
                });
              }
              return sl;
            });
          } else {
            slist = this.sl[0];
            if (slist.candidates == null) {
              slist.candidates = [];
            }
            cids = slist.candidates.map((c) => {
              return c._id;
            });
            rows = [];
            if (candi) {
              candi.map((c) => {
                var ref1;
                if (!(ref1 = c._id, indexOf.call(cids, ref1) >= 0)) {
                  return rows.push(c);
                }
              });
            }
            app.api.update({
              tableName: 'searchlists',
              _id: slist._id,
              data: {
                $push: {
                  candidates: {
                    $each: rows
                  }
                }
              }
            }).then((sl) => {
              if (candi) {
                return candi.map((c) => {
                  return app.api.update({
                    tableName: 'candidates',
                    _id: c._id,
                    data: {
                      searchlists: {
                        [`${slist._id}`]: '1'
                      }
                    }
                  });
                });
              }
            });
            return slist;
          }
        });
      }).then((con) => {
        if (con) {
          return router.push(`/searchlists/${con._id}`);
        }
      });
    }
  }
};
</script>

